export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

export function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;
  const mobileTrigger = getWindowSize(800);

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit').first().attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');

    if (!mobileTrigger) {
      $searchBox.attr('tabindex', '0');
    }
  }
}

export function updateContentMargin() {
  let marginTimeout;

  function applyMargin() {
    const headerHeight = $('header').outerHeight();
    const mq = globalThis.matchMedia('(max-width: 1160px)');
    const additionalValue = mq.matches ? 0 : 60;
    const $content = $('.content');
    const isHomepage = $('body').hasClass('homepage');
    const hasBanner = $('body').hasClass('has-banner');

    if (hasBanner) {
      $('body .subpage-banner').css('margin-top', `${headerHeight}px`);
      $content.css('margin-top', 0);
    } else {
      $content.css(
        'margin-top',
        isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
      );
    }
  }

  function applyMarginAfterResize() {
    clearTimeout(marginTimeout);
    marginTimeout = setTimeout(applyMargin, 300);
  }

  applyMargin();

  $(globalThis).on('resize', applyMargin);

  const $header = $('header');

  if ($header.length) {
    const resizeObserver = new ResizeObserver(applyMarginAfterResize);
    resizeObserver.observe($header[0]);
  }
}

export function modifyFeatureLineup() {
  const $lineups = $('.featureLineupContainer');
  if (!$lineups.length) return;

  $lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const $buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const $icons = $buttonContainer.find('.featureLineup-social');
    const $cta = $buttonContainer.find('.featureLineup-buynow');

    if (!$icons.children().length) {
      $icons.remove();
      $buttonContainer.addClass('no-social');
      return;
    }

    if (!$cta.children().length) {
      $buttonContainer.addClass('no-buy');
      return;
    }

    const totalWidth = $icons.outerWidth(true) + $cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      $buttonContainer.addClass('column');
    }
  });
}

export function missingWidget(widgetName) {
  $('body').addClass(`${widgetName}-no-data`);
}
